import { styled } from '@mui/material/styles';
import { Box, Typography, Chip, Avatar } from '@mui/material';

export const StatusContainer = styled(Box)(({ theme }) => ({
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: 'rgba(33, 150, 243, 0.1)',
    borderRadius: theme.shape.borderRadius,
    border: '1px solid rgba(33, 150, 243, 0.3)',
}));

export const StatusHeader = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
}));

export const StatusChip = styled(Chip)(({ theme }) => ({
    marginRight: theme.spacing(2),
    backgroundColor: 'rgb(33, 150, 243)',
    color: 'white',
    fontWeight: 600,
}));

export const StatusTitle = styled(Typography)(({ theme }) => ({
    color: theme.palette.info.dark,
}));

export const StatusDescription = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.secondary,
}));

export const StatusTimestamp = styled(Typography)(({ theme }) => ({
    display: 'block',
    marginTop: theme.spacing(1),
    color: theme.palette.text.secondary,
}));

export const SwapStatusContainer = styled(Box)(({ theme }) => ({
    padding: theme.spacing(2),
    backgroundColor: 'rgba(33, 150, 243, 0.1)',
    borderRadius: theme.shape.borderRadius,
    marginBottom: theme.spacing(2),
    border: '1px solid rgba(33, 150, 243, 0.3)',
    boxShadow: '0 2px 8px rgba(33, 150, 243, 0.1)',
}));

export const SwapStatusHeader = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
    gap: theme.spacing(2),
}));

export const SwapStatusRightContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: theme.spacing(1),
}));

export const SwapStatusChip = styled(Chip)(({ theme }) => ({
    backgroundColor: 'rgb(33, 150, 243)',
    color: 'white',
    fontWeight: 600,
    marginTop: theme.spacing(1),
}));

export const SwapStatusAvatar = styled(Avatar)(({ theme }) => ({
    width: 32,
    height: 32,
}));

export const SwapStatusTitle = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.primary,
    fontWeight: 600,
    marginBottom: theme.spacing(0.5),
}));

export const SwapStatusDescription = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.secondary,
    lineHeight: 1.4,
}));

export const LoadingContainer = styled(Box)(({ theme }) => ({
    padding: theme.spacing(2),
    backgroundColor: 'rgba(33, 150, 243, 0.1)',
    borderRadius: theme.shape.borderRadius,
    marginBottom: theme.spacing(2),
    border: '1px solid rgba(33, 150, 243, 0.3)',
}));
